var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"type":"number","value":_vm.number},on:{"input":_vm.updated},scopedSlots:_vm._u([{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}],null,true)},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }